import { h } from 'preact';
import React, { Component } from 'react';
import { makeText, isActionAllowed } from '../../../util';

export default class Switch extends Component {
  render() {
    const {
      checked,
      value: { name: ariaLabel },
      value,
      dev,
      settings,
      language,
      page
    } = this.props;

    const backgroundColor = checked ? settings.toggleColor : settings.toggleOffColor;

    const toggleOnText = makeText(Boolean(dev), settings, 'toggleOnText', language);
    const toggleOffText = makeText(Boolean(dev), settings, 'toggleOffText', language);

    const hasText = toggleOnText || toggleOffText;
    const hasTextClass = hasText ? ' has-text' : '';

    const basicClassName = checked ? ('cat-switch checked' + hasTextClass) : ('cat-switch' + hasTextClass);
    return (
      <button
        className={basicClassName}
        aria-label={btnText}
        tabIndex="0"
        type="button"
        role="switch"
        aria-checked={checked ? "true" : "false"}
        onKeyDown={(e) => isActionAllowed(e.key) && this.props.toggle(value._id, !checked, page)}
      >
        <span
          className={checked ? 'slider round is-checked' : 'slider round'}
          style={{ backgroundColor }}
          onClick={() => this.props.toggle(value._id, !checked, page)}
        >
           {checked ? toggleOnText : toggleOffText }
        </span>
      </button>
    );
  }
}
